const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_jrSFxZoLV',
      userPoolClientId: 'm065252j7os915v9ti2e8mnk1',
      loginWith: {
        email: true,
      },
    },
  },
};

export default awsConfig;
